var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "10px",
    viewBox: "0 0 18 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Form-/-Select-field-/-Filled",
    transform: "translate(-424.000000, -27.000000)",
    fillRule: "nonzero",
    fill: "#E5E5EA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.715005,27.3030187 C441.334925,26.9210368 440.717667,26.9200857 440.335686,27.3001609 L432.993313,34.6140023 L425.665083,27.2857731 C425.284053,26.9047423 424.66677,26.9047423 424.285764,27.2857731 C423.904758,27.666804 423.904733,28.2840862 424.285764,28.6650926 L432.302653,36.6810062 C432.493168,36.8715216 432.742747,36.9667854 432.992313,36.9667854 C433.240928,36.9667854 433.490518,36.8715265 433.681021,36.6829083 L441.713274,28.6813824 C442.094305,28.3022537 442.096207,27.6849959 441.715179,27.303014 L441.715005,27.3030187 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.c22a57e0faa2363b4077e38ebaa18159.svg";
export { ForwardRef as ReactComponent };